import { cva } from 'class-variance-authority';
import type { ChangeMagnitude } from './types';

export const similarityVariants = cva('font-medium tabular-nums', {
  variants: {
    level: {
      high: 'text-green-700 dark:text-green-400',
      medium: 'text-amber-700 dark:text-amber-400',
      low: 'text-red-700 dark:text-red-400',
    },
  },
});

export const similarityLevel = (percentage: number) => {
  if (percentage >= 90) return 'high';
  if (percentage >= 70) return 'medium';
  return 'low';
};

export const distributionToneVariants = cva('rounded-lg border p-4 text-center', {
  variants: {
    tone: {
      none: 'bg-muted/30 text-muted-foreground',
      minimal: 'bg-green-50 text-green-800 dark:bg-green-950/40 dark:text-green-300',
      moderate: 'bg-amber-50 text-amber-800 dark:bg-amber-950/40 dark:text-amber-300',
      major: 'bg-red-50 text-red-800 dark:bg-red-950/40 dark:text-red-300',
    },
  },
});

export const MAGNITUDE_BADGE_VARIANT: Record<ChangeMagnitude, 'success' | 'warning' | 'error'> = {
  minimal: 'success',
  moderate: 'warning',
  major: 'error',
};

export const diffContainerClasses =
  'max-h-[240px] overflow-y-auto whitespace-pre-wrap rounded-lg border bg-muted/30 p-4 text-sm ' +
  '[&_.diff-added]:bg-green-100 [&_.diff-added]:text-green-900 ' +
  '[&_.diff-removed]:bg-red-100 [&_.diff-removed]:text-red-900 [&_.diff-removed]:line-through ' +
  'dark:[&_.diff-added]:bg-green-950 dark:[&_.diff-added]:text-green-200 ' +
  'dark:[&_.diff-removed]:bg-red-950 dark:[&_.diff-removed]:text-red-200';

export const summaryTextClasses =
  'max-h-[300px] overflow-y-auto whitespace-pre-wrap rounded-lg border bg-muted/30 p-4 font-sans text-sm';

export const chartFrameClasses = 'h-[280px] w-full aspect-auto';

export const emptyStateClasses =
  'flex h-[200px] items-center justify-center rounded-md border border-dashed text-muted-foreground text-sm';
